import React from 'react';

import styled from '@emotion/styled';

import { media } from '../../services/media';
import { colors } from '../../global';

interface PlusIconProps {
    type: 'green' | 'orange';
    onClick: any;
}

export const PlusIcon: React.FC<PlusIconProps> = ({ type, onClick }) => {
    return (
        <Figure type={type} onClick={onClick}>
            +
        </Figure>
    );
};

const Figure = styled.figure<PlusIconProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 32px;
    height: 32px;

    margin: 0;

    font-family: ${(props) => props.theme.headings.fontFamily};
    font-size: 33px;
    font-weight: 300;
    line-height: 0;
    color: white;

    border-radius: 50%;
    background-color: ${colors.bonJour};
    background-image: ${colors.turquoiseGreenGradient};
    box-shadow: 8px 10px 16px 0 rgba(0, 0, 0, 0.45);

    ${media.min('xl')} {
        width: 78px;
        height: 78px;

        font-size: 65px;

        box-shadow: 15px 37px 50px rgba(0, 0, 0, 0.45);
    }

    ${(props) =>
        props.type === 'orange' &&
        `
            background-color: ${colors.bonJour};
            background-image: linear-gradient(to top, #ffd865 0%, #fa7134 100%);
    `}

    ${(props) =>
        props.onClick &&
        `
            cursor: pointer;
    `}
`;
